import { render } from "./TSSearchBar.vue?vue&type=template&id=b736316c"
import script from "./TSSearchBar.vue?vue&type=script&lang=js"
export * from "./TSSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__